import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Badge, Card, CardContent, EmptyState, PageLoading } from "@dosa/ui";
import { listAllAppointments } from "../../lib/api-client";

const statusVariant = { REQUESTED: "warning", CONFIRMED: "success", IN_PROGRESS: "info", COMPLETED: "neutral", CANCELLED: "neutral", NO_SHOW: "high" } as const;

export function AdminAppointmentsPage() {
  const { t } = useTranslation();
  const { data: appointments, isLoading } = useQuery({ queryKey: ["all-appointments"], queryFn: listAllAppointments });

  if (isLoading) return <PageLoading />;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.appointments.title")}</h1>
      <Card>
        <CardContent className="p-0">
          {!appointments || appointments.length === 0 ? (
            <EmptyState className="border-0" title={t("common.noResults")} />
          ) : (
            <ul className="divide-y divide-charcoal-100">
              {appointments.map((a) => (
                <li key={a.id} className="flex items-center justify-between px-5 py-4">
                  <div>
                    <p className="font-medium text-charcoal-800">{new Date(a.scheduledAt).toLocaleString()}</p>
                    <p className="text-sm text-charcoal-400">{a.type.replaceAll("_", " ")}</p>
                  </div>
                  <Badge variant={statusVariant[a.status]}>{a.status}</Badge>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
